<script lang="ts">
  import { faCheck, faCopy, faXmark } from '@fortawesome/free-solid-svg-icons'
  import type { CategoryMeta } from '../categories'
  import { getI18n } from '../i18n'
  import type { SerializedPlace } from '../types'
  import { copyToClipboard } from '../utils/clipboard'
  import Button from './Button.svelte'
  import Icon from './Icon.svelte'

  const OUTLINE_VARIANTS = { brand: 'brand-outline', warning: 'warning-outline', success: 'success-outline' } as const
  const FEEDBACK_DURATION = 2000

  // `iconOnly` keeps the label for screen readers only.
  let { place, variant, iconOnly = false }: { place: SerializedPlace; variant: CategoryMeta['variant']; iconOnly?: boolean } = $props()

  const i18n = getI18n()
  let state = $state<'idle' | 'copied' | 'failed'>('idle')
  let resetTimeout: ReturnType<typeof setTimeout> | undefined

  const label = $derived(
    state === 'copied' ? i18n.t('map.copied') : state === 'failed' ? i18n.t('map.copyFailed') : i18n.t('map.copyAddress'),
  )
  const icon = $derived(state === 'copied' ? faCheck : state === 'failed' ? faXmark : faCopy)

  async function copy() {
    state = (await copyToClipboard(`${place.name}, ${place.street}, ${place.postalCode} ${place.city}`)) ? 'copied' : 'failed'
    clearTimeout(resetTimeout)
    resetTimeout = setTimeout(() => (state = 'idle'), FEEDBACK_DURATION)
  }

  $effect(() => () => clearTimeout(resetTimeout))
</script>

<Button variant={OUTLINE_VARIANTS[variant]} onclick={copy}>
  {#snippet start()}<Icon {icon} />{/snippet}
  <span class={['copy-address-button-label', { '-hidden': iconOnly }]} aria-live="polite">{label}</span>
</Button>

<style>
  .copy-address-button-label.-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
</style>
